import React from 'react'
import { flowRight } from 'lodash'
import { withTranslationCustom } from 'lib/i18next'
import AppHeaderLogo from 'components/AppHeader/AppHeaderLogo/AppHeaderLogo'

import './app-header-mobile-logo.css'

const AppHeaderMobileLogo = ({ t }) => {
    return (
        <div className="app-header-mobile-logo">
            <AppHeaderLogo title={t('common:appTitle')} />
        </div>
    )
}

export default flowRight(
    withTranslationCustom(),
)(AppHeaderMobileLogo)
